import { View, Text, Image } from "@react-pdf/renderer";
import type { FC } from "react";
import styles from "./pdfStyles";

interface PdfChartProps {
  title?: string | null;
  imageDataUrl: string;
}

export const PdfChart: FC<PdfChartProps> = ({ title, imageDataUrl }) => (
  <View wrap={false}>
    {title && <Text style={styles.blockTitle}>{title}</Text>}
    <Image src={imageDataUrl} style={styles.chartImage} />
  </View>
);
